import { AxiosInstance } from "axios";

import { ICatchIssueUseCase } from "../catch-issue.usecase";

interface IHandleResponse {
  success: boolean;
  message?: string;
}

type RemoveBookmarkContentUseCaseProps = {
  handle: (content_id: number) => Promise<IHandleResponse>
}

export class RemoveBookmarkContentUseCase implements RemoveBookmarkContentUseCaseProps {
  constructor (
    private readonly url: string,
    private readonly http: AxiosInstance,
    private readonly catchIssueUseCase: ICatchIssueUseCase
  ){}

  async handle(content_id: number): Promise<IHandleResponse> {
    try {
      await this.http.delete<{ success: true }>(`${this.url}/${content_id}`);
      
      return {
        success: true,
        message: 'Conteúdo removido dos favoritos com sucesso!'
      };
    } catch (error) {
      this.catchIssueUseCase.handle({
        error,
        errorName: 'RemoveBookmarkContentUseCase',
        extras: {
          content_id
        }
      });

      return {
        success: false,
        message: 'Falha ao remove conteúdo dos favoritos! Por favor tente novamente mais tarde'
      }
    }
  }
 }